import { gate } from 'hub-http/gates';
const LANDING_PAGES_ABM_AGENT_ACCESS = gate('LP:ABMAgentAccess');
const CRO_AGENT_ALL = gate('Pages::CROAgent:All');
const PERSONALIZATION = gate('Permissions:Personalize');
const AI_EDITOR_EXPERIMENT = gate('PageEditorAIEditingExperiment');
const STUDIO_MEASURE_ONE_TO_MANY_LANDING_PAGE = gate('StudioMeasure:OneToMany:LandingPage');
const WORKFLOWS_MODERN_EDITOR = gate('Workflows:ModernEditor');
const CONTENT_STAGING_BUFFER_APPROACH = gate('ContentStaging:BufferApproach');
const PAGES_BREEZE_ASSISTANT_LANDING_PAGE_SKILL = gate('Pages::BreezeAssistant::LandingPageSkill');
const EDITOR_V2_MULTILANG = gate('ContentEditor:V2:MultiLangVariantPlugin');
const NEW_PAGE_CREATION_FLOW = gate('E2.0:NewPageCreationFlow');
const SOFT_DELETE_PAGES = gate('AdminAutomation::PocSoftDeletePages');
const EDITOR_V2_SITE_PAGES = gate('Pages::E2::WebsitePagesEditingAndManagement');
const EDITOR_TWO_DOT_O_OPTIN = gate('LandingPages:EditorTwoDotO:Optin');
export const Gates = {
  LANDING_PAGES_ABM_AGENT_ACCESS,
  CRO_AGENT_ALL,
  PERSONALIZATION,
  AI_EDITOR_EXPERIMENT,
  STUDIO_MEASURE_ONE_TO_MANY_LANDING_PAGE,
  WORKFLOWS_MODERN_EDITOR,
  CONTENT_STAGING_BUFFER_APPROACH,
  PAGES_BREEZE_ASSISTANT_LANDING_PAGE_SKILL,
  EDITOR_V2_MULTILANG,
  NEW_PAGE_CREATION_FLOW,
  SOFT_DELETE_PAGES,
  EDITOR_V2_SITE_PAGES,
  EDITOR_TWO_DOT_O_OPTIN
};